// extracted by mini-css-extract-plugin
export var container = "headline-module--container--fedbd";
export var sub = "headline-module--sub--684aa";